import { autoinject } from 'aurelia-framework';

@autoinject
export class ContactUs {

  private subject: string = 'MediaBeat | Contact Us';
  private email: string;
  private firstName: string;
  private surname: string;
  private contactNumber: string;
  private company: string;
  private message: string;
  private error: any = {
    name: false,
    email: false,
    message: false
  };

  public attached(): void {
    
  }

  public submit(): void {

    this.validate()
      .then(() => {
        this.resetValidation();

        const body = 
        `From:\t\t\t${this.firstName} ${this.surname}\n` +
        `Contact Number:\t${this.contactNumber}\n` +
        `Company:\t\t${this.company}\n` +
        `Message:\t\t${this.message}\n\n` +
        `${this.email}`;

        console.log(' ::>> submit email');

        window.open(`mailto:admin@mediabeat.co.za?subject=${encodeURIComponent(this.subject)}&body=${encodeURIComponent(body)}`);
        this.resetForm();
      });
  }

  private validate(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.resetValidation();

      if (!this.firstName || !this.isValidString(this.firstName)) {
        this.error.name = true;
      }
      if (!this.surname || !this.isValidString(this.surname)) {
        this.error.name = true;
      }
      if (!this.email || !this.isValidEmail(this.email)) {
        this.error.email = true;
      }

      if (!this.message) {
        this.error.message = true;
      }

      const hasError = Object.values(this.error).find((i) => { return i; });
      console.log(' ::>> hasError', hasError);

      if (!hasError) {
        resolve({});
      }
    });
  }

  private isValidString(value: string): boolean {
    const regex = /[A-Z][a-z]+(\s|,)[A-Z][a-z]{19}/g;
    return !regex.test(value);
  }
  
  private isValidEmail(value: string): boolean {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value);
  }

  private resetValidation(): void {
    this.error = {
      name: false,
      email: false,
      message: false
    };
  }

  private resetForm(): void {
    this.firstName = '';
    this.surname = '';
    this.contactNumber = '';
    this.email = '';
    this.company = '';
    this.message = '';
  }
}